import PropTypes from 'prop-types';
import Entity from '@/common-utils/components/renders/entity/Entity';
import getTranslatedText from '@/common-utils/functions/getTranslatedText';
import { nsCustomization } from '@/app/i18n/namespaces';

const PAYMENT_TRIGGERS_PREFIX = 'details.functionnalities.payment_triggers';
const EXTERNAL_TRIGGER_PREFIX = `${PAYMENT_TRIGGERS_PREFIX}.options.externalTrigger`;

const MODE_ENTITY_BY_SUFFIX = {
    CASHIER: `${EXTERNAL_TRIGGER_PREFIX}.title`,
    MANUEL: `${PAYMENT_TRIGGERS_PREFIX}.options.amountScreenDisplay.title`,
    DONS: `${PAYMENT_TRIGGERS_PREFIX}.options.donationMode.title`,
    AUTOMATE: `${PAYMENT_TRIGGERS_PREFIX}.options.automateMode.title`
};

/**
 * @param {string} modeSuffix
 * @returns {string|undefined}
 */
function getModeEntity(modeSuffix) {
    return MODE_ENTITY_BY_SUFFIX[modeSuffix];
}

/**
 * @param root0
 * @param root0.value
 * @returns {JSX|null}
 */
function RenderPayluddMpfMode({ value }) {
    if (!value) {
        return null;
    }

    if (typeof value === 'string') {
        const modeEntity = getModeEntity(value);
        if (!modeEntity) {
            return null;
        }
        return (
            <Entity
                className='font-bold'
                entity={modeEntity}
                namespace={nsCustomization}
            />
        );
    }

    const { mode, enabledOptions = [], allConfigurationsEnabled, port, speedRate } = value;
    const modeEntity = getModeEntity(mode);
    const detailsLabel = allConfigurationsEnabled
        ? getTranslatedText(`${EXTERNAL_TRIGGER_PREFIX}.all_cashier_options`, nsCustomization)
        : enabledOptions
            .map((optionKey) => getTranslatedText(`${EXTERNAL_TRIGGER_PREFIX}.${optionKey}`, nsCustomization))
            .join(' / ');

    const configParts = [];
    if (port !== undefined) {
        configParts.push(`${getTranslatedText(`${PAYMENT_TRIGGERS_PREFIX}.keys.port`, nsCustomization)} ${port}`);
    }
    if (speedRate !== undefined) {
        configParts.push(
            `${getTranslatedText(`${PAYMENT_TRIGGERS_PREFIX}.keys.exchange_speed`, nsCustomization)}: ${speedRate} bps`
        );
    }

    return (
        <div className='flex flex-col gap-1 font-bold'>
            <div className='flex flex-wrap items-baseline gap-x-1.5'>
                {modeEntity && (
                    <Entity
                        entity={modeEntity}
                        namespace={nsCustomization}
                    />
                )}
                {detailsLabel && (
                    <>
                        <span>-</span>
                        <span>{detailsLabel}</span>
                    </>
                )}
            </div>
            {configParts.length > 0 && (
                <div className='flex flex-col'>
                    {configParts.map((configPart) => (
                        <span key={configPart}>{configPart}</span>
                    ))}
                </div>
            )}
        </div>
    );
}

RenderPayluddMpfMode.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
            mode: PropTypes.string,
            enabledOptions: PropTypes.arrayOf(PropTypes.string),
            allConfigurationsEnabled: PropTypes.bool,
            port: PropTypes.number,
            speedRate: PropTypes.number
        })
    ])
};

export default RenderPayluddMpfMode;
